import React from 'react';
import { Link } from 'react-router-dom';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="nav">
            <Link to="/" className="logo">
              <img src="/icon.png" alt="Gym Edge" className="logo-image" />
              <span className="logo-text">Gym Edge</span>
            </Link>
            <nav className="nav-links">
              <a href="/#features">Features</a>
              <a href="/#download">Download</a>
              <Link to="/support">Support</Link>
              <a href="/#contact">Contact</a>
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main>
        {children}
      </main>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>Gym Edge</h4>
              <p>Built for lifters who just want their tracking to work.</p>
            </div>
            <div className="footer-section">
              <h4>Community</h4>
              <ul>
                <li><a href="https://discord.gg/ZFZ3aaH3vt" target="_blank" rel="noopener noreferrer">Discord Server</a></li>
                <li><a href="#feedback" className="link-placeholder">Send Feedback</a></li>
                <li><Link to="/support">Support</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Legal</h4>
              <ul>
                <li><a href="/privacy-android.html">Privacy Policy (Android)</a></li>
                <li><a href="/privacy-ios.html">Privacy Policy (iOS)</a></li>
                <li><a href="#terms" className="link-placeholder">Terms of Service</a></li>
                <li><a href="#contact" className="link-placeholder">Contact</a></li>
              </ul>
            </div>
            <div className="footer-section" id="contact">
              <h4>Contact</h4>
              <p>support@glassedgesoftware.com</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Glass Edge Limited. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
